import { useContext, useContextSelector } from 'use-context-selector';
import { MediaStateContext } from '../../providers/media-state-provider';
export const useMediaState = () => {
  return useContext(MediaStateContext);
};
export const useMediaStateUpdateFrameLoadStatus = () => {
  return useContextSelector(MediaStateContext, s => s.updateFrameLoadStatus);
};
export const useMediaStateMediaFrameLoadStatus = () => {
  return useContextSelector(MediaStateContext, s => s.mediaFrameLoadStatus);
};
export const useMediaStateIsFramesLoading = () => {
  return useContextSelector(MediaStateContext, s => s.isFramesLoading);
};
export const useMediaStateOnSeekToFrame = () => {
  return useContextSelector(MediaStateContext, s => s.onSeekToFrame);
};
export const useMediaStateIsPlaying = () => {
  return useContextSelector(MediaStateContext, s => s.isPlaying);
};
export const useMediaStateGetFrameTime = () => {
  return useContextSelector(MediaStateContext, s => s.getFrameTime);
};
export const useMediaStatePlaySpeed = () => {
  return useContextSelector(MediaStateContext, s => s.playSpeed);
};
export const useMediaStateMediaElement = () => {
  return useContextSelector(MediaStateContext, s => s.mediaElement);
};